import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';

/**
 * Map Icon Cell Renderer
 * Displays map icon button
 */
@Component({
  selector: 'app-map-icon-cell-renderer',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule, MatTooltipModule],
  template: `
    <button
      mat-icon-button
      (click)="onMapClick()"
      color="primary"
      matTooltip="Ver mapa">
      <mat-icon svgIcon="heroicons_outline:map"></mat-icon>
    </button>
  `,
  styles: [`
    :host {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
    }
  `]
})
export class MapIconCellRendererComponent implements CellRenderer<any, any> {
  @Input() params!: CellRendererParams<any, any>;

  onMapClick(): void {
    if (this.params?.onMapClick) {
      this.params.onMapClick(this.params.data);
    }
  }
}
